import React from "react";
import background from "../../../assets/mic.webp";
import section from "../../../assets/Section.png";
import { FaAngleRight } from "react-icons/fa";
import { useRouter } from "next/router";
const TrendingTopic = ({ category }) => {
  const router = useRouter();

  const Categories = category?.category?.slice(0, 8);

  // console.log(Categories);
  return (
    <section
      style={{ background: `url(${background.src})` }}
      className="relative h-auto !bg-no-repeat !bg-center !bg-cover z-10"
    >
      <div className="absolute top-0 left-0 w-full h-full bg-[#d4d4ec]  opacity-90  dark:bg-gray-900 -z-10"></div>
      <div className="py-10">
        <p className="text-3xl md:text-6xl text-blue-600 font-bold text-center">
          Explore Trending Topics.
        </p>

        <div className="md:grid md:grid-cols-4 gap-5 mx-2 mt-10 md:mt-20">
          {Categories &&
            Categories?.map((category, i) => (
              <div
                key={i}
                style={{ background: `url(${section.src})` }}
                onClick={() => router.push(`/category?id=${category?._id}`)}
                className="relative h-auto !bg-no-repeat !bg-center !bg-cover z-10 rounded-xl mt-2 cursor-pointer"
              >
                <div className="absolute top-0 left-0 w-full h-full bg-[#5e5ec4]  opacity-90  dark:bg-[#2b2b92] -z-10 rounded-xl"></div>
                <p className="pt-16 pb-5 flex gap-2 text-5 text-white font-bold ml-5">
                  {" "}
                  <FaAngleRight className="my-auto  bg-blue-400 rounded-full text-2xl" />{" "}
                  {category?.name}
                </p>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default TrendingTopic;
